module.exports = "<div class=\"progress-indicator\">\r\n  <div class=\"progress-bar-container\">\r\n    <div\r\n      class=\"progress-bar\"\r\n      [style.width]=\"(done / toDo) * 100 + '%'\"\r\n    ></div>\r\n  </div>\r\n  <div class=\"info\">{{done}} / {{toDo}}</div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/ProgressIndicatorComponent/progressIndicator.component.html
// module id = ./src/app/common/components/ProgressIndicatorComponent/progressIndicator.component.html
// module chunks = main